<template>
	<div class="container" v-loading="loading">
		<div class="container-header">
			<!-- <div class="title">通行证</div> -->
			<div class="logo">
				<img :src="require('@/assets/zhicheng/logo.png')" alt="">
			</div>
			<div class="txz">
				<div class="left">
					<img :src="require('@/assets/zhicheng/left.png')" alt="">
				</div>
				<div class="center">
					<img :src="require('@/assets/zhicheng/txz.png')" alt="">
				</div>
				<div class="right">
					<img :src="require('@/assets/zhicheng/right.png')" alt="">
				</div>
			</div>
			<div class="container-center">
				<div class="card" ref="warterMark">
					<img :src="require('@/assets/zhicheng/xiaoren.png')" alt="">
					<div class="info">
						<div class="headphoto" :style="bgstyle">
							<!-- <img src='../../../assets/zhicheng/default.png' /> -->
						</div>
						<div class="person-info">
							<div v-if="teacherData.XM">
								<span class="xm fix-width"><span>姓</span><span>名</span></span>：
								<span style="font-weight:bold;">{{ teacherData.XM }}</span>
							</div>
							<div v-if="teacherData.XH">
								<span class="xhg fix-width">学号/工号</span>：
								<span style="font-weight:bold;">{{ teacherData.XH }}</span></div>
							<div v-if="teacherData.YX">
								<span class="yx fix-width">院系/部门</span>：
								<span style="font-weight:bold;">{{ teacherData.YX }}</span></div>
							<div v-if="teacherData.BJ">
								<span class="bj fix-width">班级/单位</span>：
								<span style="font-weight:bold;">{{teacherData.BJ }}</span></div>
						</div>

						<div class="qrimg">
							<div id="qrCode" ref="qrCodeDiv"></div>
						</div>
						<div class="msg">
							<div class="msg-green" v-if="teacherData.qrcolor == '1'">
								{{cutString(msg)}}
							</div>
							<div class="msg-gray" v-if="teacherData.qrcolor == '2'">
								{{cutString(msg)}}
							</div>
							<div class="msg-blue" v-if="teacherData.qrcolor == '3'">
								{{cutString(msg)}}
							</div>
							<div class="msg-yellow" v-if="teacherData.qrcolor == '4'">
								{{cutString(msg)}}
							</div>
							<div class="msg-red" v-if="teacherData.qrcolor == '0'">
								{{cutString(msg)}}
							</div>
						</div>
						<div class='time'>
							<div class="current-time">
								<div class="hour">
									{{hour}}
								</div>
								<span>:</span>
								<div class="minute">
									{{minute}}
								</div>
								<span>:</span>
								<div class="second">
									{{second}}
								</div>
								<span>:</span>
								<div class="millsecond">
									{{millsecond}}
								</div>
							</div>
							<div class="current-date">
								<div class="line"></div>
								<div class="updateDate">{{updateDate}}</div>
								<div class="line"></div>
							</div>
						</div>
						<p class="cph" v-if="cph!='0'">{{cph}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="foot">
			
			<img :src="require('@/assets/zhicheng/foot.png')" alt="">
			<div class="copyright">
				版权所有©福州大学至诚学院ICP备案号：闽ICP备14016203
			</div>
		</div>
	</div>
</template>
<script>
import QRCode from "qrcodejs2";
import {
	getaccountJxScan
} from "@/api/zhicheng.js";
import Watermark from "../../../utils/warterMark";
export default {
	data() {
		return {
			loading: false,
			username: '',
			teacherData: {},
			hour: '',
			minute: '',
			second: '',
			millsecond: '',
			updateDate: '',
			updateTime: '',
			timer: '',
			code: 0,
			val: '',
			urlParamsList: '',
			msg: '',
			bgstyle:{
			        backgroundImage: `url(${require("@/assets/zhicheng/default.png")})` 
			      },
			cph:''
		}
	},
	methods: {
		cutString(str) {
			if (str.length < 50) {
				return str
			} else {
				let newStr = str.substring(0, 50) + '......';
				return newStr;
			}
		},
		handTeacherElectronicDocuments() {
			this.loading = true;
			let data = {
				urlParamsList: this.urlParamsList
			}
			getaccountJxScan(data).then((res) => {
				console.log(res);
				let _this = this;
				if (res) {
					_this.teacherData = res.data;
					_this.val = res.data.XH; //二维码值 学号
					_this.msg = res.data.qrmessage //红码 消息
					if(res.data.CPH){
						_this.cph = res.data.CPH; //车牌号
					}
					if(res.data.IDPIC){
						_this.bgstyle.backgroundImage = 'url(data:image/jpg;base64,' + res.data.IDPIC + ')'//头像
					}
					const imgWidth = 140
					const imgHeight = 140
					if (_this.teacherData.qrcolor == "1") {
						new QRCode(_this.$refs.qrCodeDiv, {
							text: _this.val,
							width: imgWidth,
							height: imgHeight,
							colorDark: "green", //二维码颜色
							colorLight: "#ffffff", //二维码背景色
							correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
						});
					} else if (_this.teacherData.qrcolor == '2') {
						new QRCode(_this.$refs.qrCodeDiv, {
							text: _this.val,
							width: imgWidth,
							height: imgHeight,
							colorDark: "gray", //二维码颜色
							colorLight: "#ffffff", //二维码背景色
							correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
						});
					} else if (_this.teacherData.qrcolor == '3') {
						new QRCode(_this.$refs.qrCodeDiv, {
							text: _this.val,
							width: imgWidth,
							height: imgHeight,
							colorDark: "blue", //二维码颜色
							colorLight: "#ffffff", //二维码背景色
							correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
						});
					} else if (_this.teacherData.qrcolor == '4') {
						new QRCode(_this.$refs.qrCodeDiv, {
							text: _this.val,
							width: imgWidth,
							height: imgHeight,
							colorDark: "yellow", //二维码颜色
							colorLight: "#ffffff", //二维码背景色
							correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
						});
					} else if (_this.teacherData.qrcolor == '0') {
						new QRCode(_this.$refs.qrCodeDiv, {
							text: _this.val,
							width: imgWidth,
							height: imgHeight,
							colorDark: "#F1292E", //二维码颜色
							colorLight: "#ffffff", //二维码背景色
							correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
						});
					}
					this.loading = false;
				}
			});
		},

		handleUrlInfo() {
			let urlInfo = window.location.href;
			let urlParams = urlInfo.split("?");
			this.urlParamsList = urlParams[1];
		},
		timeFormate(timeStamp) {
			let year = new Date(timeStamp).getFullYear();
			let month =
				new Date(timeStamp).getMonth() + 1 < 10 ?
				"0" + (new Date(timeStamp).getMonth() + 1) :
				new Date(timeStamp).getMonth() + 1;
			let date =
				new Date(timeStamp).getDate() < 10 ?
				"0" + new Date(timeStamp).getDate() :
				new Date(timeStamp).getDate();
			let hh =
				new Date(timeStamp).getHours() < 10 ?
				"0" + new Date(timeStamp).getHours() :
				new Date(timeStamp).getHours();
			let mm =
				new Date(timeStamp).getMinutes() < 10 ?
				"0" + new Date(timeStamp).getMinutes() :
				new Date(timeStamp).getMinutes();
			let ss =
				new Date(timeStamp).getSeconds() < 10 ?
				"0" + new Date(timeStamp).getSeconds() :
				new Date(timeStamp).getSeconds();

			let ms =
				new Date(timeStamp).getMilliseconds() < 10 ?
				"00" + new Date(timeStamp).getMilliseconds() :
				new Date(timeStamp).getMilliseconds() < 100 ?
				"0" + new Date(timeStamp).getMilliseconds() :
				new Date(timeStamp).getMilliseconds();
			this.updateDate =
				year + "年" + month + "月" + date + "日";
			this.hour = hh;
			this.minute = mm;
			this.second = ss;
			this.millsecond = ms;
		},
		nowTimes() {
			this.timeFormate(new Date());
		},

	},
	mounted() {
		this.handleUrlInfo();
		this.handTeacherElectronicDocuments();
		Watermark.set(this.updateDate, this.$refs.warterMark);
	},
	created() {
		this.nowTimes()
		this.timer = setInterval(this.nowTimes, 1)
	},
	beforeDestroy() {
		clearInterval(this.timer);
	},
}
</script>
<style lang="scss" scoped>
	.container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		background: #F9F9F9;

		.fix-width {
			display: inline-block;
			width: 54px;

			&.xm {
				display: flex;
				justify-content: space-between;
			}
		}

		.foot {
			display: flex;
			flex-direction: column;
			justify-content: center;
		}

		.time {
			color: rgb(61, 116, 197);
			text-align: center;
			font-size: 28px;
			font-weight: 600;
			line-height: 30px;
			padding-top: 10px;
		}

		.container-header {
			width: 100%;
			height: 201px;
			background: #1574DF;

			.title {
				font-size: 18px;
				font-family: PingFangSC-Regular, PingFang SC;
				color: #fff;
				text-align: center;
				padding-top: 30px;
				line-height: 24px;
			}

			.logo {
				img {
					transform: translateX(50%);
					width: 180px;
					height: 28px;
					position: absolute;
					top: 20px;
				}
			}

			.txz {
				display: flex;
				justify-content: center;
				align-items: center;
				position: relative;

				.left {
					img {
						width: 64px;
						height: 68px;
						position: absolute;
						top: 37px;
						left: 2px;
					}
				}

				.center {
					img {
						width: 110px;
						height: 34px;
						position: absolute;
						top: 60px;
						transform: translateX(-50%);
					}
				}

				.right {
					img {
						width: 88px;
						height: 104px;
						position: absolute;
						top: 10px;
						right: 1px;
					}
				}
			}
		}

		.container-center {
			display: flex;
			justify-content: center;
			position: relative;
			margin-top: 101px;
			height: 100%;

			.card {
				// margin-top: -40px;
				border-radius: 10px;
				width: 350px;
				height: calc(100vh - 200px);
				box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
				background: #fff;
				max-height: 480px;
				img {
					width: 60px;
					height: 72px;
					top: -61px;
					right: 46px;
					position: absolute;
				}
			}

			.info-items {
				width: 86px;
				text-align: justify;
			}

			.info {
				display: flex;
				flex-direction: column;
				z-index: 100001;
				text-align: center;
				position: relative;
				height: 100%;
				.headphoto{
					width: 140px;
					height: 196px;
					position: absolute;
					left: 20px;
					top: 10px;
					z-index: 99;
					// background: url(../../../assets/zhicheng/default.png) no-repeat;
					background-size: 100% auto;
					background-repeat: no-repeat;
				}
				.person-info {
					font-size: 12px;
					color: #333;
					font-family: PingFangSC-Regular, PingFang SC;
					line-height: 22px;
					margin-right: 20px;
					padding: 20px 0;
					height: 170px;
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					padding-left: 45vw;
					justify-content: space-evenly;
					flex: 1;
					div {
						display: flex;
						width: 155px;
						white-space: nowrap;
					}

					.xm,
					.xhg,
					.yx,
					.bj {
						color: #999999;
					}
				}

				.qrimg {
					z-index: 2;
					width: 158px;
					height: 158px;
					padding: 2px;
					border: 7px solid #1574DF;
					border-radius: 14px;
					margin: 0 auto;
				}

				.msg {
					font-size: 12px;
					padding-top: 10px;
					line-height: 12px;
					width: 100%;
					margin: 0 auto;

					.msg-green {
						color: green;
					}

					.msg-red {
						color: #F1292E;
					}

					.msg-gray {
						color: gray;
					}

					.msg-yellow {
						color: yellow;
					}

					.msg-blue {
						color: blue;
					}
				}
				.cph{
					display: flex;
					color: red;
					margin: 0 auto;
					font-size: 32px;
					position: absolute;
					bottom: -40px;
					width: 100%;
					justify-content: center;
				}
				.time {
					display: flex;
					flex-direction: column;
					justify-content: center;
					margin: 0 auto;

					.current-time {
						display: flex;

						span {
							color: #1574DF;
							line-height: 44px;
						}

						.hour {
							display: flex;
							background-image: url('../../../assets/zhicheng/time-two.png');
							background-repeat: no-repeat;
							background-size: 100% 100%;
							font-size: 28px;
							line-height: 44px;
							padding: 0 12px;
							color: #fff;
							width: 64px;
							height: 44px;
							letter-spacing: 10px;

						}

						.minute {
							display: flex;
							background-image: url('../../../assets/zhicheng/time-two.png');
							background-repeat: no-repeat;
							background-size: 100% 100%;
							font-size: 28px;
							line-height: 44px;
							padding: 0 12px;
							color: #fff;
							width: 64px;
							height: 44px;
							letter-spacing: 10px;
						}

						.second {
							display: flex;
							background-image: url('../../../assets/zhicheng/time-two.png');
							background-repeat: no-repeat;
							background-size: 100% 100%;
							font-size: 28px;
							color: #fff;
							line-height: 44px;
							padding: 0 12px;
							width: 64px;
							height: 44px;
							letter-spacing: 10px;
						}

						.millsecond {
							display: flex;
							background-image: url('../../../assets/zhicheng/time-three.png');
							background-repeat: no-repeat;
							background-size: 100% 100%;
							font-size: 28px;
							color: #fff;
							line-height: 44px;
							padding: 0 10px;
							width: 95px;
							height: 44px;
							letter-spacing: 14px;
						}
						
					}
					
					.current-date {
						display: flex;
						padding-top: 4px;
						padding-left: 6px;

						.updateDate {
							font-size: 14px;
							color: #1574DF;
							padding: 0 15px;
						}

						.line {
							width: 85px;
							height: 15px;
							opacity: 0.4;
							border-bottom: 2px solid #1574DF;
						}

					}
				}
			}
		}

		.foot {
			

			img {
				width: 65%;
				// margin-left: 72px;
				// margin-top: 354px;
				padding-bottom: 5px;
				position: fixed;
				bottom: 30px;
				left: 17.5%;
			}

			.copyright {
				position: fixed;
				bottom: 0;
				width: 100%;
				color: #fff;
				font-size: 12px;
				background: #1574DF;
				text-align: center;
				height: 22px;
				line-height: 22px;
			}
		}
	}
</style>